import React, {Component, Fragment} from 'react';
import {Button} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import ModalManager from '../../components/modal/ModalManager';
import {reactTableText} from '../../constants/configs';
import {keyBy, mapValues} from 'lodash';
import {mask, getStatusColor, i18nizeDate} from '../../helpers/Utils';
import {NotificationManager} from '../../components/common/react-notifications';
import ReactTableTextFilter from '../../components/ReactTableTextFilter';
import BankAccountDetails from '../BankAccountDetails';
import BankAccountFormV2 from "../BankAccountFormV2";
import Rbac from '../../components/Rbac';
import Api from '../../services/Api';


class CardNumbers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      pages: -1,
      loading: false,
      expanded: props.filteredCardNumber ? {0: true} : {},
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/user-bank-account/card-number',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            userId: this.props.userId,
            ...(state.filtered.length ? mapValues(keyBy(state.filtered, 'id'), 'value') : null),
          }
        },
      );
      this.setState({
        accounts: data.rows,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  deleteBankAccount = async accountId => {
    const {t, userId} = this.props;
    try {
      await Api.invoke(
        'DELETE',
        '/v2/admin-ui/user-bank-account/card-number',
        {
          userId,
          accountId
        },
      );
      NotificationManager.success(t('Card number deleted successfully'), t('Message'));
      this.table.fireFetchData();
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressDelete = accountId => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this card number ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            this.deleteBankAccount(accountId);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  renderBankAccountForm = () => {
    return (
      <BankAccountFormV2
        type="card-number"
        userId={this.props.userId}
        fireFetchData={() => {this.table.fireFetchData();}}
      />
    );
  };

  onPressAdd = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Add Card Number'),
      body: this.renderBankAccountForm(),
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  getColumns = t => [
    {
      Header: t('Title'),
      accessor: 'title',
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Card Number'),
      accessor: 'cardNumber',
      minWidth: 150,
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{mask(props.value, '####-####-####-####')}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: ({filter, onChange}) => (
        <select
          style={{width: '100%'}}
          value={filter ? filter.value : t('all')}
          onChange={event => onChange(event.target.value)}
        >
          <option value="">{t('all')}</option>
          <option value="Pending">{t('Pending')}</option>
          <option value="Rejected">{t('Rejected')}</option>
          <option value="Verified">{t('Verified')}</option>
        </select>
      ),
      Cell: props => <span className={getStatusColor(props.value)}>{t(props.value)}</span>,
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Actions'),
      Cell: props => <div>
        <i className="simple-icon-trash delete-icon mx-3 cursor-pointer"
           onClick={() => {this.onPressDelete(props.original.id);}}
        />
      </div>,
      minWidth: 30,
      show: Rbac.hasPermission('delete_user-bank-accounts')
    },
  ];

  updateList = (values, index) => {
    const {accounts} = this.state;
    let list = [...accounts];
    list.splice(index, 1, {...accounts[index], ...values});
    this.setState({accounts: list});
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Rbac permission='create_user-bank-accounts'>
          <div className="d-flex flex-row justify-content-end align-items-center mt-2 mb-4">
            <Button onClick={this.onPressAdd}>
              <i className="simple-icon-plus add-reply-icon"/>
              <span className="mx-1">{t('Add')}</span>
            </Button>
          </div>
        </Rbac>
        <ReactTable
          manual
          ref={el => {this.table = el;}}
          className="-highlight"
          data={this.state.accounts}
          pages={this.state.pages}
          loading={this.state.loading}
          sortable={false}
          resizable={true}
          expanded={this.state.expanded}
          onPageChange={() => {this.setState({expanded: {}});}}
          onExpandedChange={this.onExpanded}
          onFetchData={this.fetchData}
          columns={this.getColumns(t)}
          defaultPageSize={5}
          style={{
            width: '100%',
          }}
          defaultFiltered={[
            {
              id: 'cardNumber',
              value: this.props.filteredCardNumber,
            }
          ]}
          {...reactTableText}
          SubComponent={row =>
            <BankAccountDetails
              itemIndex={row.index}
              bankAccount={row.original}
              updateList={this.updateList}
            />
          }
        />
      </Fragment>
    );
  }
}

export default withTranslation()(CardNumbers);
